import { ReactComponent as EyeClosed } from "../../img/icons/icon_black_eye_slash.svg";
import { ReactComponent as EyeOpned } from "../../img/icons/icon_black_eye.svg";
import { ReactComponent as Lock } from "../../img/create-new-pwd.svg";
import { ReactComponent as GreenTick } from "../../img/icons/icon_tick_green.svg";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
import { parsePID } from "../../utils";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

function CreateNewPasswordPage() {
  const [state, setState] = useState({ pwd: "", confirmPwd: "" });
  const history = useHistory();
  const { t } = useTranslation();
  const [validation, setValidation] = useState({ message: "", status: true });
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    validator();
  }, [state]);

  const validator = () => {
    if (state.pwd === "" && state.confirmPwd === "") {
      setValidation({
        message: "",
        status: false,
      });
    } else if (state.pwd && state.pwd !== state.confirmPwd) {
      setValidation({
        message: t("sidenav.PASSWORD.message5"),
        status: false,
      });
    } else if (state.confirmPwd.length < 8) {
      setValidation({
        message: t("sidenav.PASSWORD.message3"),
        status: false,
      });
    } else {
      setValidation({ message: "", status: true });
    }
  };

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const URL = "/api/v1/users/password";

  const onSubmit = (data) => {
    setIsFetching(true);
    fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        tid: token,
        patientId: parsePID(pid),
        password: state.pwd,
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          history.push("/login");
        }
      })
      .finally(() => setIsFetching(false));
  };

  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const toggleIsPasswordShowValue = () => {
    setIsPasswordShow(!isPasswordShow);
  };

  return (
    <div className="pwd_content ">
      <div className="thumbnail wow zoomIn mt-4">
        <Lock className="img-fluid" />
      </div>
      <div className="section_title">
        <h4 className="maintitle">{t("sidenav.PASSWORD.message")}</h4>
      </div>
      <div className="fill_form light_fill_form">
        <div className="field_group field_lbl_active">
          <label className="field_lbl">{t("sidenav.PASSWORD.message2")}</label>
          <input
            type={isPasswordShow ? "text" : "password"}
            className="field_input field_black_pwd"
            placeholder=""
            autoComplete="off"
            name="pwd"
            onChange={handleChange}
            value={state.pwd}
          />
          {state.pwd && (
            <span
              className="icon btn_black_pwd"
              onClick={toggleIsPasswordShowValue}
            >
              {isPasswordShow ? (
                <EyeOpned className="img-fluid img_eye_black" />
              ) : (
                <EyeClosed
                  className="img-fluid img_eye_black"
                  id="img_eye_black"
                />
              )}
            </span>
          )}

          <span className="txt_help">{t("sidenav.PASSWORD.message3")}</span>
        </div>
        <p className="headtitle text-start mb-4">
          {t("sidenav.PASSWORD.message4")}
        </p>
        <div className="field_group field_lbl_active">
          <label className="field_lbl">{t("sidenav.PASSWORD.message4")}</label>
          <input
            type="text"
            className="field_input"
            placeholder=""
            autoComplete="off"
            name="confirmPwd"
            onChange={handleChange}
            value={state.confirmPwd}
          />
          {validation.status && state.pwd !== "" && (
            <span className="icon btn_black_pwd">
              <GreenTick className="img-fluid" />
            </span>
          )}
          {validation.status && (
            <span className="txt_help txt_color_green">
              {t("sidenav.PASSWORD.message7")}
            </span>
          )}
          {!validation.status && state.confirmPwd !== "" && (
            <span className="txt_help " style={{ color: "red" }}>
              {validation.message}
            </span>
          )}
        </div>
        <div className="btn_block d-flex justify-content-center bottom_button">
          <button
            className="btn btn_primary"
            onClick={() => onSubmit()}
            disabled={!validation.status}
          >
            {isFetching && (
              <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
            )}
            &nbsp;{t("appointment.BUTTON.save")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateNewPasswordPage;
